module.exports = "const itemsArray = [...] // This is our data\n\nfunction rowRenderer ({ index, key, style }) {\n  return (\n    <div\n      key={index}\n      style={style}\n    >\n      {itemsArray[index].name}\n    </div>\n  )\n}\n\nfunction renderList () {\n  return (\n    <List\n      height={240}\n      width={240}\n      rowHeight={26}\n      rowCount={itemsArray.length}\n      rowRenderer={rowRenderer}\n    />\n  )\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./examples/perf-comparison-virtualized.js
 ** module id = 290
 ** module chunks = 0
 **/